module.exports = __webpack_public_path__ + "static/images/containers/WGCWXShop/containers/WGCWXShopProducts/components/WGCWXShopCard/images/products/CREW_BOOK_NATIONAL.RU.3ea5b66a.png";


//////////////////
// WEBPACK FOOTER
// ./containers/WGCWXShop/containers/WGCWXShopProducts/components/WGCWXShopCard/images/products/CREW_BOOK_NATIONAL.RU.png
// module id = 1269
// module chunks = 16